(function() {
	'use strict';

	angular.module('wamasysApp').controller('AdminToolsController', AdminToolsController);

	AdminToolsController.$inject = [ '$scope', '$http', '$filter','$state', 'AdminTools', 'Organisation', 'AlertService', 'UserAdmin', 'Principal', '$interval' ];

	function AdminToolsController($scope, $http, $filter,$state, AdminTools, Organisation,	AlertService, UserAdmin, Principal, $interval) {
		var vm = this;
        // Les outils occasionnels restent repliés ; le suivi ouvre la réparation si nécessaire.
        vm.adminSections = [
            {id: 'diagnostic', title: 'Diagnostic Elasticsearch', description: 'Comparer les données et examiner les écarts.', open: true, template: 'app/business/admin-tools/diagnostic.html'},
            {id: 'recovery', title: 'Réparer les données Elasticsearch', description: 'Reprendre ou reconstruire les périodes de reporting.', open: false, template: 'app/business/admin-tools/recovery.html'},
            {id: 'support', title: 'Maintenance et support', description: 'Documentation et déblocage du portail client.', open: false, template: 'app/business/admin-tools/support.html'},
            {id: 'advanced', title: 'Intégrations et maintenance avancée', description: 'Exports immédiats, purge, rôles et comptes Redmine.', open: false, template: 'app/business/admin-tools/advanced.html'},
            {id: 'demo', title: 'Démonstration et tests', description: 'Créer, compléter ou anonymiser des données de test.', open: false, template: 'app/business/admin-tools/demo.html'}
        ];

		vm.numberOfContractByCluster = 50;
		vm.coefMultiplicateur = 1;
		vm.coefNbrYear = 2;
		vm.generationMode = 'JAVA_COHERENT';
		vm.sqlContractCount = 100000;
		vm.organisations = Organisation.query();
		vm.agences = UserAdmin.getAllAgency();

		vm.anonymiserArea = function() {
			if (vm.anonymisationNotProduction) {
				AdminTools.anonymiserArea({
					orgaId : vm.anonymisationOrganisationId,
					areaId : vm.anonymisationAreaId,
					password : vm.anonymisationPassword
				}, function (data){
					AlertService.success("Demande acceptée.");
				}, function (error){
					AlertService.error(error.data.message);
				});
			}
		};


		vm.createAreaTest = function() {
				AdminTools.createAreaTest({
					orgaName : vm.orgaName,
					orgaId : vm.orgaId,
					password : vm.generationPassword,
					codeArea : vm.codeArea,
					codeLangue :vm.codeLangue,
					areaName : vm.areaName, 
					agenceName : vm.agenceName, 
					numberOfContractByCluster : vm.numberOfContractByCluster,
					coefMultiplicateur : vm.coefMultiplicateur,
					coefNbrYear : vm.coefNbrYear,
					generationMode : vm.generationMode,
					sqlContractCount : vm.sqlContractCount
			}, function (data){
				AlertService.success("Demande acceptée.");
			}, function (error){
				AlertService.error(error.data.message);
			});
		};
		
		
		vm.injecterJeuTesta = function() {
			if (vm.injectionNotProduction) {
				AdminTools.completerDonneesTest({
						idOrga : vm.injectionOrganisationId,
						idAgence : vm.injectionAreaId
				}, function (data){
					AlertService.success("Demande acceptée.");
				}, function (error){
					AlertService.error(error.data.message);
				});
			}
		};
		

		vm.initialiserroleareaelastic = function() {
			
			AdminTools.initialiserroleareaelastic({}, function (data){
				AlertService.success("Demande acceptée.");
			}, function (error){
				AlertService.error(error.data.message);
			});
			
		};
		
		vm.exportEventsInElastic= function() {
            var period = getExportPeriod();

			AdminTools.exportAllEventInElastic({
                fromDate: period.fromDate,
                toDate: period.toDate,
                purgeBeforeExport: vm.purgeBeforeExport
            }, function (data){
				AlertService.success("Demande acceptée.");
			}, function (error){
				AlertService.error(error.data.message);
			});
			
		};

		vm.indexManualDocs = function() {
			AdminTools.indexManualDocs({}, function(data) {
				var message = 'Documentation indexée';
				if (data && data.chunkCount) {
					message += ' : ' + data.chunkCount + ' fragments';
				}
				AlertService.success(message);
			}, function(error) {
				AlertService.error((error.data && error.data.message) || 'Indexation documentation impossible');
			});
		};

		vm.clearClientPortalResetRateLimit = function() {
			AdminTools.clearClientPortalResetRateLimit({}, function(data) {
				AlertService.success('Blocages du portail client levés. Compteurs supprimés : ' + (data || 0));
			}, function(error) {
				AlertService.error((error.data && error.data.message) || 'Purge du rate limit impossible');
			});
		};

		vm.majTeamwork = function() {
			
			AdminTools.majTeamwork({idOrga : vm.teamworkOrgaId}, function (data){
				AlertService.success("Demande acceptée.");
			}, function (error){
				AlertService.error(error.data.message);
			});
			
		};
		
		
        $scope.openRangeDateTimePicker = function(inputId) {
				var picker = $('#' + inputId).data('daterangepicker');
				if (picker) {
					picker.toggle();
				}
		}

        
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.toDatecheckExport = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
		vm.datePeriod = {
                startDate: null,
                endDate: null
        };
        vm.elasticResult = null;
        vm.checkExportRows = [];
        vm.elasticActions = [];
        vm.elasticProcessing = false;
        vm.purgeBeforeExport = false;

        function getExportPeriod() {
            var dateFormat = 'yyyy-MM-dd';
            return {
                fromDate: $filter('date')(new Date(vm.datePeriod.startDate), dateFormat),
                toDate: $filter('date')(new Date(vm.datePeriod.endDate), dateFormat)
            };
        }

        function parseElasticResponse(data) {
            if (angular.isString(data)) {
                try {
                    return angular.fromJson(data);
                } catch (e) {
                    return {raw: data};
                }
            }
            return data;
        }

        function displayElasticResponse(data) {
            vm.elasticResult = parseElasticResponse(data);
            vm.checkExportRows = vm.elasticResult && vm.elasticResult.rows ? vm.elasticResult.rows : [];
            vm.elasticActions = vm.elasticResult && vm.elasticResult.actions ? vm.elasticResult.actions : [];
        }

        function postElasticExport(url, successMessage) {
            vm.elasticProcessing = true;
            return $http.post(url).then(function(msg) {
                displayElasticResponse(msg.data);
                AlertService.success(successMessage || 'Traitement Elastic terminé');
            }, function(error) {
                AlertService.error((error.data && error.data.message) || 'Traitement Elastic impossible');
            }).finally(function() {
                vm.elasticProcessing = false;
            });
        }

		vm.exportElkCheckexport = function(){

		    var url = 'api/export/checkexport?toDate=' + $filter('date')(new Date(vm.toDatecheckExport), "yyyy-MM-dd");
		    postElasticExport(url, 'Comparaison Elastic terminée');
			
//			AdminTools.exportElkCheckexport( {
//				toDate:$filter('date')(new Date(vm.toDatecheckExport), "yyyy-MM-dd")
//    			}, function (data){
//				AlertService.success("success, response:"+data);
//				}, function (error){
//					AlertService.error(error.data.message);
//				});
    	}
		
		
		vm.exportElkFacturation = function(){
			
            var period = getExportPeriod();
			
            
			 var url = 'api/export/facturation?fromDate='+period.fromDate+'&toDate=' + period.toDate;
		    postElasticExport(url, 'Export facturation terminé');
		    
//			AdminTools.exportElkFacturation( {
//        		fromDate:fromDate,
//        		toDate:toDate
//    			}, function (data){
//				AlertService.success("success, response:"+data);
//				}, function (error){
//					AlertService.error(error.data.message);
//				});
    	}
		
		
		vm.exportElkWaterConsumption = function(){
			
            var period = getExportPeriod();
			
            
			 var url = 'api/export/consommationeau?fromDate='+period.fromDate+'&toDate=' + period.toDate;
		    postElasticExport(url, 'Export consommation eau terminé');

    	}
		
		
		
		vm.exportElkStatContrat = function(){
			
            var period = getExportPeriod();
			
            
			 var url = 'api/export/stat_contrat?fromDate='+period.fromDate+'&toDate=' + period.toDate;
		    postElasticExport(url, 'Export statistiques contrats terminé');

    	}
		
		
		
		
		vm.exportElkContrat = function(){
			
            var period = getExportPeriod();
			
            
			 var url = 'api/export/contracts?fromDate='+period.fromDate+'&toDate=' + period.toDate;
		    postElasticExport(url, 'Export contrats terminé');

    	}

        vm.reexportCategories = [
            {code: 'RECEIPTS', label: 'Reçus de paiement', selected: true},
            {code: 'INVOICES', label: 'Factures PDF', selected: false},
            {code: 'BILLING', label: 'Facturations, paiements et ajustements', selected: false},
            {code: 'WATER', label: 'Consommations d’eau', selected: false},
            {code: 'STATS', label: 'Statistiques contrats', selected: false},
            {code: 'CONTRACTS', label: 'Contrats', selected: false}
        ];
        // ng-options préserve les valeurs numériques avec AngularJS 1.5.
        vm.reexportChunkOptions = [
            {days: 1, label: '1 jour — pour mesurer la durée'},
            {days: 3, label: '3 jours'},
            {days: 7, label: '7 jours'}
        ];
        vm.reexportPurgeBeforeExport = false;
        vm.reexportHasContractsSelected = function() {
            return vm.reexportCategories.some(function(category) { return category.code === 'CONTRACTS' && category.selected; });
        };
        vm.reexportChunkDays = 1;
        vm.reexportJobs = [];
        vm.reexportBusy = false;
        vm.reexportStatusLabel = function(status) {
            return {QUEUED: 'En attente', RUNNING: 'En cours', ERROR: 'En erreur', SUCCESS: 'Terminée'}[status] || status;
        };
        vm.reexportCategoryLabel = function(code) {
            for (var i = 0; i < vm.reexportCategories.length; i++) {
                if (vm.reexportCategories[i].code === code) { return vm.reexportCategories[i].label; }
            }
            return code;
        };
        var reexportAttentionKey;
        vm.refreshReexportJobs = function() {
            return $http.get('api/export/reexport-jobs').then(function(response) {
                vm.reexportJobs = response.data;
                // Ouvrir sur une nouvelle demande ou erreur, sans empêcher le repli pendant le suivi.
                var attentionKey = vm.reexportJobs.filter(function(job) {
                    return job.status === 'QUEUED' || job.status === 'RUNNING' || job.status === 'ERROR';
                }).map(function(job) {
                    return job.id + ':' + (job.status === 'ERROR' ? 'ERROR' : 'ACTIVE');
                }).join(',');
                if (attentionKey && attentionKey !== reexportAttentionKey) {
                    vm.adminSections[1].open = true;
                }
                reexportAttentionKey = attentionKey;
                vm.reexportActive = vm.reexportJobs.some(function(job) {
                    return job.status === 'QUEUED' || job.status === 'RUNNING';
                });
            }, function(error) {
                AlertService.error((error.data && error.data.message) || 'Chargement des reprises Elastic impossible');
            });
        };
        vm.startReexportJob = function() {
            if (!vm.datePeriod.startDate || !vm.datePeriod.endDate) {
                AlertService.error('Choisissez les dates de début et de fin de la période.');
                return;
            }
            var categories = vm.reexportCategories.filter(function(category) { return category.selected; })
                .map(function(category) { return category.code; });
            if (!categories.length) {
                AlertService.error('Sélectionnez au moins une catégorie.');
                return;
            }
            if (vm.reexportPurgeBeforeExport && vm.reexportHasContractsSelected()) {
                AlertService.error('La purge par période ne s’applique pas aux contrats. Décochez Contrats ou désactivez la purge.');
                return;
            }
            var period = getExportPeriod();
            vm.reexportBusy = true;
            return $http.post('api/export/reexport-jobs', null, {params: {
                fromDate: period.fromDate, toDate: period.toDate,
                categories: categories.join(','), chunkDays: vm.reexportChunkDays,
                purgeBeforeExport: vm.reexportPurgeBeforeExport
            }}).then(function() {
                AlertService.success('Reprise enregistrée' + (vm.reexportPurgeBeforeExport ? ' avec purge des périodes' : ' sans purge') + '. Le traitement continue en arrière-plan.');
                return vm.refreshReexportJobs();
            }, function(error) {
                AlertService.error((error.data && error.data.message) || 'Démarrage de la reprise impossible');
            }).finally(function() { vm.reexportBusy = false; });
        };
        vm.resumeReexportJob = function(job) {
            vm.reexportBusy = true;
            return $http.post('api/export/reexport-jobs/' + job.id + '/resume').then(function() {
                return vm.refreshReexportJobs();
            }, function(error) {
                AlertService.error((error.data && error.data.message) || 'Reprise du traitement impossible');
            }).finally(function() { vm.reexportBusy = false; });
        };
        var reexportTimer;
        var reexportDestroyed = false;
        Principal.hasAuthority('ROLE_SUPER_ADMIN').then(function(allowed) {
            if (!allowed || reexportDestroyed) { return; }
            vm.refreshReexportJobs();
            reexportTimer = $interval(function() {
                if (vm.reexportActive) { vm.refreshReexportJobs(); }
            }, 5000);
        });
        $scope.$on('$destroy', function() {
            reexportDestroyed = true;
            if (reexportTimer) { $interval.cancel(reexportTimer); }
        });

		vm.reexportElasticPeriod = function(){
            var period = getExportPeriod();
            var url = 'api/export/reexport-period?fromDate=' + period.fromDate + '&toDate=' + period.toDate + '&purgeBeforeExport=' + vm.purgeBeforeExport;
		    postElasticExport(url, 'Réexport Elastic terminé');

    	}
		
		vm.exportElkDiscountCreditNoteRefund = function(){
			
            var period = getExportPeriod();
			
            
			 var url = 'api/export/credit_note_refund?fromDate='+period.fromDate+'&toDate=' + period.toDate;
		    postElasticExport(url, 'Export avoirs, factures PDF et reçus terminé');

    	}
	}
})();
